export const messageSx = {
	textAlign: "center",
	width: "100%",
};

export const linkSx = {
	"&:hover": {
		color: "var(--color-text-action-hover)",
	},
	color: "var(--color-text-action-base)",
	cursor: "pointer",
	fontFamily: "var(--font-family-body)",
	fontSize: "var(--font-size-small)",
	fontWeight: "var(--font-weight-base)",
	letterSpacing: "var(--font-letter-spacing)",
};

export const wrapperSx = {
	textAlign: "left",
	width: "100%",
};
